import { TypeProfileInterface } from "../contracts/TypeProfile.interface";

export class TypeProfile implements TypeProfileInterface {
  nomeConsultaApiBase = "perfil-tipo";
  id: number;
  cdPerfilTipo: string;
  nmPerfilTipo: string;
}
